(() => {
  const initPurchaseUi = (root = document) => {
    const info =
      root.querySelector('.product__info-container') ||
      document.querySelector('.product__info-container');

    if (
      !info ||
      info.dataset.gmmPurchaseUiInitialized === 'true'
    ) {
      return;
    }

    info.dataset.gmmPurchaseUiInitialized = 'true';

    /**
     * Air Product Reviews
     * レビュー件数が0件ならサマリーブロックを非表示にする。
     */
    const syncReviewSummary = () => {
      const summary = info.querySelector(
        '.AirReviews-Widget--AppBlockSummary'
      );

      if (!summary) return;

      const block = summary.closest('.shopify-app-block');
      const countElement = summary.querySelector(
        '.AirReviews-StarRate--Count'
      );

      if (!block || !countElement) return;

      block.classList.add('gmm-review-summary-block');

      const match = countElement.textContent
        .replace(/,/g, '')
        .match(/\d+/);

      if (!match) return;

      block.hidden = Number(match[0]) === 0;
    };

    /**
     * サイズ案内リンクを生成する。
     */
    const createSizeGuideLink = (target) => {
      const link = document.createElement('a');

      link.className = 'gmm-size-guide-link';
      link.href = `#${target.id}`;
      link.textContent = 'サイズについて';
      link.setAttribute('aria-controls', target.id);

      link.addEventListener('click', (event) => {
        event.preventDefault();

        target.open = true;

        target.scrollIntoView({
          behavior: window.matchMedia(
            '(prefers-reduced-motion: reduce)'
          ).matches
            ? 'auto'
            : 'smooth',
          block: 'start',
        });

        history.replaceState(null, '', `#${target.id}`);
      });

      return link;
    };

    /**
     * Globo Color Swatch
     *
     * 以下の表記をサイズ項目として判定する。
     * ・サイズ
     * ・サイズ：M
     * ・Size
     * ・Size : M
     * ・SIZE / XL
     * ・全角英字
     *
     * サイズ選択欄が存在しない商品では、
     * 数量欄の直前へリンクを表示する。
     */
    const syncSizeGuideLink = () => {
      const target = document.querySelector(
        '[data-gmm-size-guide]'
      );

      if (!target || !target.id) return;

      const sizeGroup = Array.from(
        info.querySelectorAll(
          '.globo-swatch-product-detail .swatch--gl'
        )
      ).find((group) => {
        const label = group.querySelector('.name-option');

        const labelText = (label?.textContent ?? '')
          .normalize('NFKC')
          .replace(/\s+/g, ' ')
          .trim();

        /*
         * 「サイズ」または「Size」で始まれば、
         * 後ろの記号・空白・選択値は問わない。
         */
        return /^(?:サイズ|size)/i.test(labelText);
      });

      const label = sizeGroup?.querySelector('.name-option');

      let link = info.querySelector(
        '.gmm-size-guide-link'
      );

      if (!link) {
        link = createSizeGuideLink(target);
      }

      /*
       * サイズ選択欄がある場合は、
       * サイズ見出しの右側へ配置する。
       */
      if (label) {
        const fallback = link.closest(
          '.gmm-size-guide-fallback'
        );

        label.append(link);

        if (fallback) {
          fallback.remove();
        }

        return;
      }

      /*
       * サイズ選択欄がない商品では、
       * 数量欄の直前へフォールバック表示する。
       */
      const quantity = info.querySelector(
        '.product-form__quantity'
      );

      if (!quantity) return;

      let fallback = info.querySelector(
        '.gmm-size-guide-fallback'
      );

      if (!fallback) {
        fallback = document.createElement('div');
        fallback.className = 'gmm-size-guide-fallback';

        quantity.before(fallback);
      }

      if (!fallback.contains(link)) {
        fallback.append(link);
      }
    };

    /**
     * レビュー・Globoは非同期でHTMLを生成するため、
     * DOM更新後にも処理する。
     */
    let scheduled = false;

    const sync = () => {
      if (scheduled) return;

      scheduled = true;

      window.requestAnimationFrame(() => {
        scheduled = false;

        syncReviewSummary();
        syncSizeGuideLink();
      });
    };

    sync();

    const observer = new MutationObserver(sync);

    observer.observe(info, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initPurchaseUi();
    });
  } else {
    initPurchaseUi();
  }

  /* Shopifyテーマエディターでの再読み込みに対応 */
  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initPurchaseUi(event.target);
    }
  );
})();